import React from 'react';
import _ from 'underscore';
import { Subtract } from 'utility-types';

import { FilterUpdaterOwnProps, withFilterUpdater } from '../../app/spaces/helpers/FilterUpdater';
import { SortOrderUpdaterOwnProps, withSortOrderUpdater } from '../../app/spaces/helpers/SortOrderUpdater';
import { ConnectedPublishedConnectionTableSpace } from './ConnectedPublishedConnectionTableSpace';
import { PublishedConnectionTableSpaceOwnProps } from './PublishedConnectionTableSpace';
import {
  InjectedPublishedConnectionTableSpaceDataFetcherProps,
  PublishedConnectionTableSpaceDataFetcherProps,
  withPublishedConnectionTableSpaceDataFetcher,
} from './PublishedConnectionTableSpaceDataFetcher';
import {
  InjectedPublishedConnectionTableSpaceServiceInjectorProps,
  PublishedConnectionTableSpaceServiceInjectorProps,
  withPublishedConnectionTableSpaceServiceInjector,
} from './PublishedConnectionTableSpaceServiceInjector';

export type PublishedConnectionTableSpaceProviderProps =
  FilterUpdaterOwnProps &
  SortOrderUpdaterOwnProps &
  PublishedConnectionTableSpaceDataFetcherProps &
  PublishedConnectionTableSpaceServiceInjectorProps &
  Subtract<Subtract<PublishedConnectionTableSpaceOwnProps, InjectedPublishedConnectionTableSpaceDataFetcherProps>, InjectedPublishedConnectionTableSpaceServiceInjectorProps>;

export const PublishedConnectionTableSpaceProvider: React.ComponentType<PublishedConnectionTableSpaceProviderProps> = _.compose(
  withFilterUpdater,
  withSortOrderUpdater,
  withPublishedConnectionTableSpaceDataFetcher,
  withPublishedConnectionTableSpaceServiceInjector,
)(ConnectedPublishedConnectionTableSpace);
